<template>
  <div v-loading="loading">
    <el-form
      class="page-form"
      ref="pageForm1"
      :model="PersonInfo"
      :rules="pageRules1"
    >
      <p class="sub_t">PersonInfo</p>
      <el-row :gutter="32">
        <el-col :span="10">
          <el-form-item prop="FirstGivenName" label="First Given Name">
            <el-input
              v-model="PersonInfo.FirstGivenName"
              type="text"
              auto-complete="off"
              placeholder="Please fill in"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item prop="FirstSurName" label="First Sur Name">
            <el-input
              v-model="PersonInfo.FirstSurName "
              type="text"
              auto-complete="off"
              placeholder="Please fill in"
            ></el-input>
          </el-form-item>
        </el-col>
        <!-- YearOfBirth MonthOfBirth DayOfBirth-->
        <el-col :span="10">
          <el-form-item prop="Birth" label="Date of Birth">
            <el-date-picker
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              style="width:100%"
              v-model="PersonInfo.Birth"
              type="date"
              placeholder="Please select"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-form
      class="page-form"
      ref="pageForm2"
      :model="NationalIds"
      :rules="pageRules2"
    >
      <p class="sub_t">NationalIds</p>
      <el-row :gutter="32">
        <el-col :span="10">
          <el-form-item prop="Number" label="Number">
            <el-input
              v-model="NationalIds.Number"
              type="text"
              auto-complete="off"
              placeholder="Please fill in"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item prop="Type" label="Type">
            <el-input
              v-model="NationalIds.Type"
              type="text"
              auto-complete="off"
              placeholder="Please fill in"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-form
      class="page-form"
      ref="pageForm3"
      :model="Location"
      :rules="pageRules3"
    >
      <p class="sub_t">Location</p>
      <el-row :gutter="32">
        <el-col :span="10">
          <el-form-item prop="BuildingNumber" label="Building Number">
            <el-input
              v-model="Location.BuildingNumber"
              type="text"
              auto-complete="off"
              placeholder="Please fill in"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item prop="StreetName" label="Street Name">
            <el-input
              v-model="Location.StreetName"
              type="text"
              auto-complete="off"
              placeholder="Please fill in"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item prop="StreetType" label="Street Type">
            <el-input
              v-model="Location.StreetType"
              type="text"
              auto-complete="off"
              placeholder="Please fill in"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item prop="City" label="City">
            <el-input
              v-model="Location.City"
              type="text"
              auto-complete="off"
              placeholder="Please fill in"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item prop="StateProvinceCode" label="State Province Code">
            <el-input
              v-model="Location.StateProvinceCode"
              type="text"
              auto-complete="off"
              placeholder="Please fill in"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item prop="PostalCode" label="Postal Code">
            <el-input
              v-model="Location.PostalCode"
              type="text"
              auto-complete="off"
              placeholder="Please fill in"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { personalKYCEntrance } from "@/api/producer.js"
export default {
  props: {
    area: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      PersonInfo:{},
      NationalIds:{},
      Location:{},
      pageRules1:{
        FirstGivenName: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (!value) {
                return callback(new Error("First Given Name cannot be empty"));
              } else {
                callback();
              }
            }
          }
        ],
        FirstSurName: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (!value) {
                return callback(new Error("First Sur Name cannot be empty"));
              } else {
                callback();
              }
            }
          }
        ],
        Birth: [
          {
            required: true,
            trigger: "change",
            message: "Date of Birth cannot be empty"
          }
        ]
      },
      pageRules2:{
        Number: [
          {
            required: true,
            trigger: "change",
            message: "Number cannot be empty"
          }
        ],
        Type: [
          {
            required: true,
            trigger: "change",
            message: "Type cannot be empty"
          }
        ]
      },
      pageRules3:{
        BuildingNumber: [
          {
            required: true,
            trigger: "blur",
            message: "Building Number cannot be empty"
          }
        ],
        StreetName: [
          {
            required: true,
            trigger: "blur",
            message: "Street Name cannot be empty"
          }
        ],
        City: [
          {
            required: true,
            trigger: "blur",
            message: "City cannot be empty"
          }
        ],
        StateProvinceCode: [
          {
            required: true,
            trigger: "blur",
            message: "State Province Code cannot be empty"
          }
        ],
        PostalCode: [
          {
            required: true,
            trigger: "blur",
            message: "Postal Code cannot be empty"
          }
        ],
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() >= Date.now();
        }
      }
    }
  },
  computed: {},
  methods: {
    submit() {
      return new Promise((resolve, reject) => {
        this.loading = true;
        let rule1,rule2,rule3;
        this.$refs.pageForm1.validate(valid => {
          rule1 = valid;
        });
        this.$refs.pageForm2.validate(valid => {
          rule2 = valid;
        });
        this.$refs.pageForm3.validate(valid => {
          rule3 = valid;
        });
        if (rule1 && rule2 && rule3) {

          if(this.Location.Address1) {
            this.Location.AdditionalFields = {
              Address1:this.Location.Address1
            }
          }
          let Location = {
            ...this.Location
          }
          delete Location.Address1;


          let PersonInfo = { ...this.PersonInfo };
          if(this.PersonInfo.Birth){
            let date = PersonInfo.Birth;
            PersonInfo.YearOfBirth = new Date(date).getFullYear();
            PersonInfo.MonthOfBirth = new Date(date).getMonth() + 1;
            PersonInfo.DayOfBirth = new Date(date).getDate();
          }
          delete PersonInfo.Birth;

          personalKYCEntrance({
            data: {
              CountryCode:this.area,
              DataFields:{
                PersonInfo: PersonInfo,
                NationalIds:(this.NationalIds.Number || this.NationalIds.Type) ? [this.NationalIds] : [],
                Location: Location
              }
            }
          })
            .then(res => {
              this.loading = false;
              // Cache the verification results after successful verification: success is 1, failure is 0, and the validity period is 180 days
              if (res.result == "nomatch") {
                this.$message.error("Matching failed !");
                reject(res.result);
              }
              else if (res.result == "match") {
                this.$message.success("Operation succeeded !");
                resolve(res.result);
              }

            })
            .catch(err => {
              console.log(err);
              reject(err);
              this.loading = false;
            });
        } else {
          reject("form valid error");
          this.loading = false;
        }
      })
    },

  },
}
</script>
<style scoped lang="scss">
.sub_t {
  font-size: 0.18rem;
  font-weight: bold;
}
.page-btns {
  margin-top:0.4rem;
  text-align: center;
}
</style>
